import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { FooterLarge } from '../../components/FooterLarge';
import { Header } from '../../components/Header';
import ProgressBanner from '../../components/progressBanner/progressBanner';
import { Audits } from './components/Audits';
import { Ecosystem } from './components/Ecosystem';
import { MainHero } from './components/Hero';
import { Phases } from './components/Phases';
import { SupportedNetworks } from './components/SupportedNetworks';
import './styles.css';

const MainPage = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, []);

  useEffect(() => {
    document.body.classList.add('main-page-bg');
    document.body.id = 'main-page-viewport';
    return () => {
      document.body.classList.remove('main-page-bg');
      document.body.id = '';
    };
  }, []);

  return (
    <div className="main-page">
      <Helmet>
        <title>Retro Bridge | All chains, single app.</title>
      </Helmet>
      <Header />
      <div className="main-page-content">
        <MainHero />
        <Ecosystem />
        <SupportedNetworks />
        <Audits />
        <Phases />
      </div>
      <ProgressBanner />
      <FooterLarge />
    </div>
  );
};

export default MainPage;
